import { useMemo } from 'react';

import { FileStatus } from 'services/file.service';
import { useAppDispatch, useAppSelector } from 'store/store-hooks';
import { useLocation, Path } from 'components/_hooks/use-router';
import { setStoryAudio } from 'components/app/_mediator/app-data.slice';
import { selectFiles } from 'components/app/_mediator/app-files.slice';

import { Option } from 'components/UI/select/select';
import { WsSelect } from './elements/ws-select';
import styles from './_ws-header.module.scss';

export const WsHeaderTitle = () => {
  const { path } = useLocation();
  const { audios } = useAppSelector(selectFiles);
  const audioId = useAppSelector((state) => state.audio.audioId);
  const fileStatuses = useAppSelector((state) => state.app__files.statuses);
  const selectedStory = useAppSelector((state) => state.projects.selectedStory);
  const finalcuts = useAppSelector((state) => state.app__data.finalcuts);
  const files = useAppSelector((state) => state.app__files.files);
  const dispatch = useAppDispatch();

  const title = useMemo(() => {
    if (!audioId) return '';
    return files[audioId]?.fileName ?? '';
  }, [audioId, files]);

  const options: Option[] = useMemo(() => {
    if (!selectedStory) return [];
    return audios.map((file) => ({
      label: file.fileName,
      value: file.id,
      disabled: fileStatuses[file.id] !== FileStatus.Available,
    }));
  }, [audios, fileStatuses, selectedStory]);

  const handleChange = async (e: React.ChangeEvent<HTMLSelectElement>) => {
    const audioFileId = +e.target.value;
    if (!selectedStory || audioFileId === audioId) return;

    try {
      await dispatch(setStoryAudio({ storyId: selectedStory, audioFileId })).unwrap();
      window.location.reload();
    } catch {
      // Controlled select stays on current audioId; toast shown by reduxErrorHandler.
    }
  };

  if (path === Path.finalcuts || (path === Path.storyboard && finalcuts.length))
    return <div className={styles.WsHeader__titleText}>{title}</div>;
  if (path === Path.storyboard)
    return <WsSelect value={audioId ?? undefined} options={options} onChange={handleChange} disabledOptions={true} />;
  return null;
};
